module.exports = __webpack_public_path__ + "static/media/syringes.c33cf220.jpg";